import { rgba } from 'polished';
import { figmaColors } from './figmaColors';
export const staticColors = {
    baseShadow: rgba(figmaColors.black, 0.1),
    appBackground: figmaColors.grey0,
    floatingSurfaceBackground: figmaColors.white,
    spinner: figmaColors.turquoise500,
    tooltipArrow: figmaColors.grey5,
    tooltipContentBackground: figmaColors.grey5,
    snackbarBackground: figmaColors.grey6,
    snackbarShadow: rgba(figmaColors.black, 0.18),
    textDark: figmaColors.grey6,
    textWhite: figmaColors.white,
    textGrey: figmaColors.grey5,
    textLightGrey: figmaColors.grey4,
    textAction: figmaColors.turquoise700,
    textLightAction: figmaColors.turquoise500,
    textWarning: figmaColors.orange700,
    textDanger: figmaColors.red700,
    textSuccess: figmaColors.green700,
    tagActionBackground: figmaColors.turquoise600,
    tagActionLightBackground: figmaColors.turquoise50,
    tagWarningBackground: figmaColors.orange900,
    tagWarningLightBackground: figmaColors.orange50,
    tagDangerBackground: figmaColors.red700,
    tagDangerLightBackground: figmaColors.red50,
    tagGreyBackground: figmaColors.grey5,
    tagGreyLightBackground: rgba(figmaColors.grey5, 0.08),
    tagSuccessBackground: figmaColors.green700,
    tagSuccessLightBackground: figmaColors.green50,
    stepperLine: figmaColors.grey3,
    stepperStepBorder: figmaColors.grey3,
    stepperActiveStepBackground: figmaColors.turquoise700,
    stepperInactiveStepBackground: figmaColors.white,
    stepperDoneStepBackground: figmaColors.grey3,
    inputBackground: figmaColors.grey0,
    inputReadOnlyBackground: 'transparent',
    inputWarningBackground: figmaColors.orange50,
    inputFocusedBorder: figmaColors.turquoise500,
    inputUnfocusedBorder: figmaColors.grey3,
    inputWarningBorder: figmaColors.orange700,
    inputCaret: figmaColors.turquoise500,
    radioChecked: figmaColors.turquoise700,
    radioUnchecked: figmaColors.grey4,
    radioHover: figmaColors.grey1,
    radioDisabled: figmaColors.grey4,
    checkboxUnchecked: figmaColors.grey4,
    checkboxHover: figmaColors.grey1,
    checkboxDisabled: figmaColors.grey4,
    checkboxChecked: figmaColors.turquoise700,
    iconAction: figmaColors.turquoise500,
    iconGrey: figmaColors.grey5,
    iconGreyLight: figmaColors.grey4,
    iconDanger: figmaColors.red600,
    iconWhite: figmaColors.white,
    iconWarning: figmaColors.orange500,
    iconSuccess: figmaColors.green500,
    hintActionBackground: figmaColors.turquoise100,
    hintWarningBackground: figmaColors.orange50,
    hintDangerBackground: figmaColors.red100,
    hintInformationBackground: figmaColors.white,
    hintDefaultBackground: rgba(figmaColors.grey5, 0.08),
    inputPlaceholder: figmaColors.grey4,
    overlayBackground: rgba(figmaColors.grey6, 0.5),
    divider: figmaColors.grey2,
    cardWhiteBackground: figmaColors.white,
    cardGreyBackground: figmaColors.grey0,
    cardGreyDarkBackground: figmaColors.grey1,
    cardActionLightBackground: figmaColors.turquoise100,
    buttonLightActionBackground: figmaColors.turquoise50,
    buttonLightActionText: figmaColors.turquoise700,
    buttonLightDangerBackground: figmaColors.red50,
    buttonLightDangerText: figmaColors.red700,
    buttonLightGreyBackground: figmaColors.grey1,
    buttonLightGreyText: figmaColors.grey5,
    buttonDarkActionBackground: figmaColors.turquoise700,
    buttonDarkActionText: figmaColors.white,
    buttonDarkDangerBackground: figmaColors.red600,
    buttonDarkDangerText: figmaColors.white,
    buttonDarkGreyBackground: figmaColors.grey5,
    buttonDarkGreyText: figmaColors.white,
    buttonUnderlineBackground: figmaColors.white,
    toolbarBackground: figmaColors.white,
    toggleCheckedBackground: figmaColors.turquoise700,
    toggleUncheckedBackground: figmaColors.grey4,
    toggleThumbBackground: figmaColors.white,
    editableTagBackground: figmaColors.white,
    editableTagBorder: figmaColors.grey3,
    navBarHorizontalGreyBackground: figmaColors.grey1,
    navBarHorizontalWhiteBackground: figmaColors.white,
    navBarHorizontalItemHoveredBackground: figmaColors.grey3,
    navBarHorizontalItemActive: figmaColors.white,
    navBarHorizontalItemActiveBackground: figmaColors.turquoise700,
    navBarHorizontalItemActiveText: figmaColors.turquoise700,
    navBarHorizontalItemDisabled: figmaColors.grey4,
    navBarHorizontalItemTransparent: figmaColors.turquoise700,
    navigationVerticalItemSelectedBackground: figmaColors.white,
    navigationVerticalItemTextColor: figmaColors.grey6,
    navigationVerticalItemDisabledTextColor: figmaColors.grey4,
    navigationVerticalItemActiveTextColor: figmaColors.turquoise700,
    navigationVerticalItemHoverTextColor: figmaColors.turquoise700,
    navigationVerticalItemTransparentTextColor: figmaColors.turquoise700,
    expansionTableHeader: figmaColors.grey1,
    tableBackground: figmaColors.white,
    tableHeaderBackground: figmaColors.turquoise100,
    tableBorder: figmaColors.grey1,
    tableCellBackgroundGray: figmaColors.grey0,
    sideTableBorder: figmaColors.turquoise500,
    dynamicTableHeaderBackground: figmaColors.grey1,
    dynamicTableRowDivider: figmaColors.grey0,
    dynamicTableRowHover: figmaColors.turquoise50,
    dynamicTablePinnedColumnBackground: figmaColors.white,
    dynamicTableUnpinnedColumnBackground: rgba(figmaColors.grey3, 0.08),
    selectItemActiveBackgroundColor: figmaColors.turquoise50,
    multiSelectItemActiveHoverBackgroundColor: figmaColors.turquoise50,
    multiSelectItemDisabledHoverBackgroundColor: figmaColors.grey0,
    calendarBackgroundSelectDate: figmaColors.turquoise700,
    calendarBackgroundHoverDate: figmaColors.turquoise50,
    calendarBorderCurrentDate: figmaColors.turquoise700,
    plainButtonFocusedBackground: figmaColors.grey1,
    infoPanelBackground: rgba(figmaColors.grey5, 0.08),
    infoPanelWarningBackground: figmaColors.orange50,
    dotWarningBackground: figmaColors.orange500,
    dotDangerBackground: figmaColors.red600,
    dotGreyBackground: figmaColors.grey4,
    dotSuccessBackground: figmaColors.green500,
};
